export default function LocationSearchComponent(module) {
    angular.module(module)
        .component('locationSearch', {
            bindings: {
                placeholder: '@',
                countries: '<?',
                apiKey: '@',
                model: '<ngModel',
                onChange: '&?'
            },
            require: {
                ngModel: 'ngModel'
            },
            template: `
                <input autocomplete="off" type="text" ng-model="vm.address" placeholder="{{vm.placeholder}}" />
                <i class="fa fa-pin"></i>
            `,
            controller: LocationSearchController,
            controllerAs: 'vm'
        });

    LocationSearchController.$inject = ['$scope', '$element', 'helper'];
    function LocationSearchController($scope, $element, helper) {
        var vm = this;

        vm.$onInit = function () {
            vm._input = $element[0].querySelector('input');
            vm._wrapListeners();
            vm._input.addEventListener('focus', vm.resetModel);

            vm._scriptReady
                .then(() => {
                    vm._autocomplete = new google.maps.places.Autocomplete(vm._input, {
                        fields: ['formatted_address', 'geometry'],
                        componentRestrictions: { country: vm.countries }
                    });
                    vm._autocomplete.addListener("place_changed", () => {
                        var place = vm._autocomplete.getPlace();
                        $scope.$evalAsync(() => {
                            vm.model = {
                                latitude: place.geometry.location.lat(),
                                longitude: place.geometry.location.lng()
                            };
                            vm.address = place.formatted_address;
                            vm.updateModel();
                            if (vm._delayedSubmit) {
                                vm._delayedSubmit = false;
                                $scope.$emit('triggerSubmit');
                            }
                        });
                    });
                });
        };

        vm.$onChanges = changes => {
            if (changes.model.isFirstChange()) {
                vm._scriptReady = helper.loadGoogleScripts(vm.apiKey);
            }
            if (changes.model.currentValue) {
                if (!vm.address && changes.model.currentValue.latitude && changes.model.currentValue.longitude) {
                    vm._scriptReady.then(() => {
                        var geocoder = new google.maps.Geocoder();
                        geocoder.geocode({
                            location: {
                                lat: vm.model.latitude,
                                lng: vm.model.longitude
                            }
                        })
                            .then(response => {
                                $scope.$evalAsync(() => {
                                    vm.address = response.results[0].formatted_address;
                                });
                            });
                    })
                }
            }
        }

        vm._wrapListeners = () => {
            var _addEventListener = vm._input.addEventListener;
            vm._input.addEventListener = (type, listener) => {
                const _listener = listener;
                switch (type) {
                    case 'keydown':
                        listener = (event) => {
                            /* Simulate a 'down arrow' keypress if no address has been selected */
                            const suggestionSelected = document.getElementsByClassName('pac-item-selected').length;
                            if (event.key === 'Enter' && !suggestionSelected) {
                                const e = new KeyboardEvent('keydown', {
                                    key: 'ArrowDown',
                                    code: 'ArrowDown',
                                    keyCode: 40,
                                });
                                event.preventDefault();
                                vm._delayedSubmit = true;
                                _listener.apply(vm._input, [e])
                            }
                            _listener.apply(vm._input, [event])
                        }
                        break;
                    case 'blur':
                        listener = (event) => {
                            const suggestionSelected = document.getElementsByClassName('pac-item-selected').length;
                            if (!suggestionSelected) {
                                event.preventDefault();
                                vm._delayedSubmit = false;
                                google.maps.event.trigger(vm._input, 'keydown', {
                                    key: 'ArrowDown',
                                    code: 'ArrowDown',
                                    keyCode: 40,
                                    stopPropagation: () => { },
                                    preventDefault: () => { }
                                });
                            }
                            _listener.apply(vm._input, [event])
                        }
                        break;
                }
                _addEventListener.apply(vm._input, [type, listener])
            }
        }

        vm.updateModel = () => {
            vm.ngModel.$setViewValue(vm.model);
            if (vm.onChange) {
                vm.onChange({
                    coordinates: vm.model
                });
            }
        };

        vm.resetModel = () => {
            if (vm.model) {
                $scope.$evalAsync(() => {
                    vm.model = undefined;
                    delete vm.address;
                    vm.updateModel();
                });
            }
        }
    }
}